import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Header from '../directives/header';
import Footer from '../directives/footer';
import '../css/launchprocess.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import {
  getAllChainList,
  insetLaunchProcessRequestAction,
  checkTokenExistence,
} from '../../apis/apiAction';
import { Toaster, toast } from 'react-hot-toast';
import Cookies from 'js-cookie';
import config from '../../config/config';
import Web3 from 'web3';
import RPC_URLS from '../../config/rpcUrls';
import erc20ABI from '../../config/erc20Abi';
import { useNavigate } from 'react-router-dom';
import StepForm from './stepform';

const Launchprocess = () => {
  const initialValues = {
    ownerAddress: '',
    tokenName: '',
    tokenSymbol: '',
    tokenAddress: '',
    chain: '',
    description: '',
    usdtToRaise: '',
    duration: '',
    promisedRoi: '',
    tokenDiscount: '',
    incentiveDiscount: '',
    feeInUtx: '',
    logo: null,
    whitepaper: null,
    kyc: null,
    audit: null,
    socials: '',
    totalSupply: '',
    exchangeName: '',
    privateSalePercentage: 0,
    preSalePercentage: 0,
    publicSalePercentage: 0,
    otherPercentage: 0,
    currentPrice: '',
    principal: '',
    maturityPeriod: '',
  };

  const validationSchema = Yup.object({
    tokenName: Yup.string().required('Token Name is required'),
    tokenSymbol: Yup.string().required('Token Symbol is required'),
    tokenAddress: Yup.string().required('Token Address is required'),
    chain: Yup.string().required('Select a Chain Network'),
    totalSupply: Yup.string().required('Total supply is required'),
    description: Yup.string()
      .max(1000, 'Max 1000 characters')
      .required('Description is required'),
    promisedRoi: Yup.number()
      .typeError('Must be a number')
      .min(10, 'Promised ROI % must be between 10-70')
      .max(70, 'Must be at most 70%')
      .required('Promised ROI is required'),
    tokenDiscount: Yup.number()
      .typeError('Must be a number')
      .min(10, 'Token discount % must be between 10-50')
      .max(50, 'Must be at most 50%')
      .required('Token discount is required'),
    incentiveDiscount: Yup.number()
      .typeError('Must be a number')
      .min(10, 'Incentive discount % must be between 10-50')
      .max(50, 'Must be at most 50%')
      .required('Incentive discount is required'),
    logo: Yup.mixed().required('Logo is required'),
    whitepaper: Yup.mixed().required('Whitepaper is required'),
    kyc: Yup.mixed().required('KYC document is required'),
    audit: Yup.mixed().required('Audit document is required'),
    socials: Yup.string().required('Socials information is required'),
    privateSalePercentage: Yup.mixed().required('Private sale is required'),
    preSalePercentage: Yup.mixed().required('Pre sale is required'),
    publicSalePercentage: Yup.string().required('Public sale is required'),
    currentPrice: Yup.number()
      .typeError('Must be a valid number')
      .positive('Must be positive')
      .required('Current Price is Required'),
    principal: Yup.number()
      .typeError('Must be a valid number')
      .positive('Must be positive')
      .required('Principal is Required'),
    maturityPeriod: Yup.number()
      .typeError('Must be a valid number')
      .positive('Must be positive')
      .required('Maturity Period is Required'),
  });

  const [chinList, setchinList] = useState([]);
  const [walletAddress, setWalletAddress] = useState(
    Cookies.get('walletAddress')
  );
  const [tokenSymbol, setTokenSymbol] = useState('');
  const [totalSupply, setTotalSupply] = useState('');
  const [currentPrice, setCurrentPrice] = useState('');
  const [invalidError, setInvalidError] = useState('');
  const [ExchangeValue, setExchangeValue] = useState();

  const [maturityValue, setMaturityValue] = useState('');
  const [maturityUnit, setMaturityUnit] = useState('days');
  const [maturityValueCount, setmaturityValueCount] = useState(0);
  const navigate = useNavigate();

  const calculateTotalDays = (value, unit) => {
    const num = parseFloat(value) || 0;
    switch (unit) {
      case 'months':
        return num * 30;
      case 'years':
        return num * 365;
      default:
        return num;
    }
  };

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({
          method: 'eth_requestAccounts',
        });
        setWalletAddress(accounts[0]);
      } catch (error) {
        toast.error('Connection failed:', error);
      }
    } else {
      toast.error('MetaMask is not installed. Please install MetaMask.');
    }
  };

  useEffect(() => {
    if (!walletAddress) {
      window.location.href = `${config.baseUrl}`;
    }

    if (window.ethereum) {
      window.ethereum.on('accountsChanged', (accounts) => {
        setWalletAddress(accounts.length > 0 ? accounts[0] : '');
      });
    }
  }, []);

  useEffect(() => {
    getChainData();
  }, []);

  const getChainData = async () => {
    let res = await getAllChainList();
    if (res.status) {
      setchinList(res.data);
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    let totalDistributePercentage =
      parseFloat(values.privateSalePercentage) +
      parseFloat(values.preSalePercentage) +
      parseFloat(values.publicSalePercentage) +
      parseFloat(values.otherPercentage);

    if (
      parseFloat(totalDistributePercentage) < 100 ||
      parseFloat(totalDistributePercentage) > 100
    ) {
      toast.error('Total allocation must be 100% of the total supply.');
      return;
    }

    if (!walletAddress) {
      toast.error('Please connect your wallet address.');
      return;
    }
    values.walletAddress = walletAddress;
    values.ownerAddress = walletAddress;
    values.totalSupply = totalSupply;
    values.currentPrice = currentPrice;
    values.tokenSymbol = tokenSymbol;
    let res = await insetLaunchProcessRequestAction({
      ...values,
      duration: '',
      feeInUtx: '',
      maturityUnit: maturityUnit,
      maturityValue: maturityValue,
    });
    if (res.status) {
      setSubmitting(false);
      toast.success(res.msg);
      navigate(`${config.baseUrl}project`);
    } else {
      toast.error(res.msg);
    }
  };

  const changeTokenAddressOrChain = async (event, setFieldValue, values) => {
    setInvalidError('');
    setExchangeValue(event.target.value);
    setFieldValue('tokenSymbol', '');
    setFieldValue('totalSupply', '');
    setFieldValue('currentPrice', '');

    // if (event.target.name == 'chain') {
    //   setFieldValue("exchangeName", !event.target.value ? "" : event.target.value === "0x61" || event.target.value === "0x61" ? 'pancakeswap' : 'uniswap');
    // }
    if (event.target.name === 'tokenAddress') {
      checkTokenDetails(values.chain, event.target.value, setFieldValue);
    } else {
      setFieldValue('chain', event.target.value);
      checkTokenDetails(event.target.value, values.tokenAddress, setFieldValue);
    }
  };

  const checkTokenDetails = async (chain, tokenAddress, setFieldValue) => {
    if (!chain) {
      toast.error('Please select a chain');
      return;
    }

    setFieldValue('tokenAddress', tokenAddress);

    if (!tokenAddress) {
      toast.error('Please enter token address');
      return;
    }

    const chainInfo = chinList.filter(item => item.chainNetworkId === chain);
    let tokenExistanceRes = await checkTokenExistence(
      {
        "tokenAddress": tokenAddress,
        "chain": chainInfo[0].chainSymbol
      }
    )
    if (tokenExistanceRes.error) {
      toast.error("Invalid token address. Please check the contract address and selected chain.");
      return;
    }

    let tokenPrice = tokenExistanceRes.liquidity?.tokenPrice
    setCurrentPrice(tokenPrice)
    setFieldValue("currentPrice", tokenPrice);

    const rpcUrl = RPC_URLS[chain];
    if (!rpcUrl) {
      toast.error('Unsupported chain selected.');
      return;
    }

    const web3 = new Web3(new Web3.providers.HttpProvider(rpcUrl));

    try {
      const code = await web3.eth.getCode(tokenAddress);
      if (code === '0x') {
        toast.error(
          'Invalid token address. Please check the contract address and selected chain.'
        );
        return;
      }

      const tokenContract = new web3.eth.Contract(erc20ABI, tokenAddress);
      const symbol = await tokenContract.methods.symbol().call();
      const totalSupply = await tokenContract.methods.totalSupply().call();
      const decimals = await tokenContract.methods.decimals().call();

      if (symbol) {
        setFieldValue('tokenSymbol', symbol);
        setTokenSymbol(symbol);
      }
      if (totalSupply) {
        setFieldValue(
          'totalSupply',
          parseFloat(
            parseFloat(totalSupply) / 10 ** parseInt(decimals)
          ).toFixed(0)
        );
        setTotalSupply(
          parseFloat(
            parseFloat(totalSupply) / 10 ** parseInt(decimals)
          ).toFixed(0)
        );
      }
    } catch (error) {
      setInvalidError(
        'Failed to fetch token details. Please enter a valid contract address.'
      );
    }
  };

  return (
    <>
      <Header />
      <Toaster />
      <section className="launchprocess">
        <Container className="position-relative">

          <Row className="align-items-center">
            <Col lg={12} className='pt-4 mb-4'>
              <StepForm />
            </Col>
            {/* <Col lg={12} className="pt-4 mb-4">
              <div className="heading my-4">
                <h1 className="text-white fw-normal">The Launch Process</h1>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="launchContent">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ setFieldValue, values, isSubmitting }) => (
                    <Form>
                      <Row>
                        {[{ label: 'Token Name', name: 'tokenName' }].map(
                          (field, index) => (
                            <Col md={6} className="mb-4" key={index}>
                              <label>{field.label}</label>
                              <Field
                                name={field.name}
                                type="text"
                                className="form-control rounded-1"
                              />
                              <ErrorMessage
                                name={field.name}
                                component="div"
                                className="text-danger"
                              />
                            </Col>
                          )
                        )}

                        <Col md={6} className="mb-4">
                          <label>Chain</label>
                          <Field
                            as="select"
                            name="chain"
                            className="form-select"
                            onChange={(e) =>
                              changeTokenAddressOrChain(
                                e,
                                setFieldValue,
                                values
                              )
                            }
                          >
                            <option value="">Select Network</option>
                            {chinList?.map((ele, index) => (
                              <option key={index} value={ele.chainNetworkId}>
                                {ele.chainName}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="chain"
                            component="div"
                            className="text-danger"
                          />
                        </Col>

                        <Col md={6} className="mb-4">
                          <label>Token Address</label>
                          <Field
                            name="tokenAddress"
                            type="text"
                            className="form-control rounded-1"
                            onChange={(e) =>
                              changeTokenAddressOrChain(
                                e,
                                setFieldValue,
                                values
                              )
                            }
                          />
                          <ErrorMessage
                            name="tokenAddress"
                            component="div"
                            className="text-danger"
                          />
                          <span style={{ color: 'red' }}>{invalidError}</span>
                        </Col>

                        {[
                          { label: 'Token Symbol', name: 'tokenSymbol' },
                          { label: 'Total Supply', name: 'totalSupply' },
                        ].map((field, index) => (
                          <Col md={6} className="mb-4" key={index}>
                            <label>{field.label}</label>
                            <Field
                              name={field.name}
                              type="text"
                              className="form-control rounded-1"
                              disabled
                            />
                            <ErrorMessage
                              name={field.name}
                              component="div"
                              className="text-danger"
                            />
                          </Col>
                        ))}

                        <Col md={6} className="mb-4">
                          <label>Current Price (IN USDT)</label>
                          <Field
                            name="currentPrice"
                            disabled
                            type="text"
                            onKeyPress={(event) => {
                              if (!/^\d*\.?\d*$/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            className="form-control rounded-1"
                          />
                          <ErrorMessage
                            name="currentPrice"
                            component="div"
                            className="text-danger"
                          />
                        </Col>

                        {[{ label: 'Socials (URL)', name: 'socials' }].map(
                          (field, index) => (
                            <Col md={6} className="mb-4" key={index}>
                              <label>{field.label}</label>
                              <Field
                                name={field.name}
                                type="text"
                                className="form-control rounded-1"
                              />
                              <ErrorMessage
                                name={field.name}
                                component="div"
                                className="text-danger"
                              />
                            </Col>
                          )
                        )}

                        {[
                          { label: 'Promised ROI (In %)', name: 'promisedRoi' },
                          {
                            label: 'Token Discount (In %)',
                            name: 'tokenDiscount',
                          },
                          {
                            label: 'Incentive Discount (In %)',
                            name: 'incentiveDiscount',
                          },
                        ].map((field, index) => (
                          <Col md={6} className="mb-4" key={index}>
                            <label>{field.label}</label>
                            <Field
                              name={field.name}
                              type="text"
                              onKeyPress={(event) => {
                                if (!/^\d*[.]?\d{0,1}$/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              className="form-control rounded-1"
                            />
                            <ErrorMessage
                              name={field.name}
                              component="div"
                              className="text-danger"
                            />
                          </Col>
                        ))}

                        <Col md={12} className="mb-4">
                          <label>Description</label>
                          <Field
                            as="textarea"
                            name="description"
                            rows={3}
                            className="form-control rounded-1"
                          />
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="text-danger"
                          />
                        </Col>

                        {[
                          {
                            label: 'Private Sale',
                            name: 'privateSalePercentage',
                          },
                          { label: 'Pre Sale', name: 'preSalePercentage' },
                          {
                            label: 'Public Sale',
                            name: 'publicSalePercentage',
                          },
                          { label: 'Other', name: 'otherPercentage' },
                        ].map((field, index) => (
                          <Col md={6} className="mb-4" key={index}>
                            <label>{field.label}</label>
                            <Field
                              name={field.name}
                              type="text"
                              placeholder="Value (In % percentage)"
                              onKeyPress={(event) => {
                                if (!/^\d*[.]?\d{0,1}$/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              className="form-control rounded-1"
                            />
                            <ErrorMessage
                              name={field.name}
                              component="div"
                              className="text-danger"
                            />
                          </Col>
                        ))}

                        {[
                          { label: 'Logo', name: 'logo', accept: 'image/*' },
                          {
                            label: 'Whitepaper (PDF)',
                            name: 'whitepaper',
                            accept: 'application/pdf',
                          },
                          {
                            label: 'KYC Document (Image)',
                            name: 'kyc',
                            accept: 'image/png, image/jpeg, image/jpg',
                          },
                          {
                            label: 'Audit Document (Image)',
                            name: 'audit',
                            accept: 'image/png, image/jpeg, image/jpg',
                          },
                        ].map((field, index) => (
                          <Col md={6} className="mb-4" key={index}>
                            <label>{field.label}</label>
                            <input
                              type="file"
                              accept={field.accept}
                              className="form-control"
                              onChange={(event) => {
                                setFieldValue(
                                  field.name,
                                  event.currentTarget.files[0]
                                );
                              }}
                            />
                            <ErrorMessage
                              name={field.name}
                              component="div"
                              className="text-danger"
                            />
                          </Col>
                        ))}

                        {[
                          { label: 'Principal (In USDT)', name: 'principal' },
                          { label: 'Maturity Period', name: 'maturityPeriod' },
                        ].map((field, index) => (
                          <Col md={6} className="mb-4" key={index}>
                            <label>{field.label}</label>

                            {field.name === 'maturityPeriod' ? (
                              <>
                                <div className="d-flex gap-2">
                                  <select
                                    className="form-select rounded-1"
                                    value={maturityUnit}
                                    onChange={(e) => {
                                      const unit = e.target.value;
                                      setMaturityUnit(unit);
                                      const totalDays = calculateTotalDays(
                                        maturityValue,
                                        unit
                                      );
                                      setFieldValue(
                                        'maturityPeriod',
                                        totalDays
                                      );
                                    }}
                                  >
                                    <option value="days">Days</option>
                                    <option value="months">Months</option>
                                    <option value="years">Years</option>
                                  </select>

                                  <input
                                    type="text"
                                    onKeyPress={(event) => {
                                      if (!/^\d*?\d*$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    className="form-control rounded-1"
                                    value={maturityValue}
                                    placeholder={`Enter ${maturityUnit}`}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setMaturityValue(value);

                                      const totalDays = calculateTotalDays(
                                        value,
                                        maturityUnit
                                      );
                                      setFieldValue(
                                        'maturityPeriod',
                                        totalDays
                                      );
                                    }}
                                  />
                                </div>

                                <div
                                  className="mt-1 text-white"
                                  style={{ fontSize: '0.9rem' }}
                                >
                                  Total Maturity (In Days):{' '}
                                  <strong>
                                    {calculateTotalDays(
                                      maturityValue,
                                      maturityUnit
                                    )}
                                  </strong>
                                </div>

                                <ErrorMessage
                                  name="maturityPeriod"
                                  component="div"
                                  className="text-danger"
                                />
                              </>
                            ) : (
                              <>
                                <Field
                                  name={field.name}
                                  type="text"
                                  onKeyPress={(event) => {
                                    if (!/^\d*\.?\d*$/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  className="form-control rounded-1"
                                />
                                <ErrorMessage
                                  name={field.name}
                                  component="div"
                                  className="text-danger"
                                />
                              </>
                            )}
                          </Col>
                        ))}
                      </Row>

                      <Col md={12} className="text-center">
                        {walletAddress ? (
                          <Button
                            type="submit"
                            disabled={isSubmitting}
                            className="border-0 fw-normal px-5 mb-4"
                          >
                            Submit
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            onClick={connectWallet}
                            className="border-0 fw-normal px-5 mb-4"
                          >
                            Connect Wallet
                          </Button>
                        )}
                      </Col>
                    </Form>
                  )}
                </Formik>
              </div>
            </Col> */}
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default Launchprocess;
